import React from 'react';
export function Hero() {
  return <section className="bg-ink relative overflow-hidden min-h-[100svh] flex flex-col p-0" data-id="element-89">
      <div className="hero-noise absolute inset-0 pointer-events-none opacity-60" data-id="element-90"></div>

      {/* Orbs */}
      <div className="absolute rounded-full blur-[80px] pointer-events-none w-[300px] h-[300px] bg-[#5C7A65]/25 -top-[80px] -right-[80px]" data-id="element-91"></div>
      <div className="absolute rounded-full blur-[80px] pointer-events-none w-[250px] h-[250px] bg-[#B85C38]/15 bottom-[60px] -left-[60px]" data-id="element-92"></div>

      <div className="mt-12 flex justify-center animate-fade-down" data-id="element-93">
        <div className="inline-flex bg-white/10 border border-white/15 text-gold text-[10px] font-semibold tracking-[0.12em] uppercase py-1.5 px-3.5 rounded-full w-fit pt-[6px] pb-[6px] gap-[6px] items-center justify-center" data-id="element-94">
          ✦ Guía digital · Acceso inmediato
        </div>
      </div>

      <div className="mt-7 flex justify-center px-6 relative z-10 animate-fade-up delay-100" data-id="element-95">
        <div className="relative w-[112px] h-[112px]" data-id="element-96">
          <div className="absolute inset-0 -m-6 rounded-full bg-[radial-gradient(circle,rgba(247,242,234,0.12)_0%,transparent_65%)] pointer-events-none" data-id="element-97"></div>
          <img src="https://cdn.magicpatterns.com/uploads/u2mqfyJ2MShh1Daa1ESBcE/mockup2.png" alt="Mockup del libro Código Hormonal junto a tablet con el contenido digital" className="relative w-full h-full object-cover rounded-2xl shadow-[0_24px_60px_rgba(0,0,0,0.45)]" data-id="element-98" />
        </div>
      </div>

      <div className="flex-1 flex flex-col px-6 pt-8 pb-12 relative z-10 items-center justify-start" data-id="element-99">
        <p className="font-sans text-[11px] font-medium tracking-[0.15em] uppercase text-sage mb-4 animate-fade-up delay-100" data-id="element-100">
          Para mujeres 28 — 55 años
        </p>

        <h1 className="font-serif font-light text-white mb-2 animate-fade-up delay-200 text-[36px]" data-id="element-101">
          Código
          <br data-id="element-102" />
          <em className="italic text-gold" data-id="element-103">Hormonal</em>
        </h1>

        <p className="font-serif text-[18px] font-light italic text-white/55 mb-5 animate-fade-up delay-300" data-id="element-104">
          La guía que tu médico no tuvo tiempo de darte
        </p>

        <div className="flex items-center justify-center gap-2 mb-8 animate-fade-up delay-300" data-id="element-105">
          <span className="inline-flex items-center gap-1.5 bg-white/5 border border-white/10 text-white/80 text-[11px] font-medium py-1.5 px-3 rounded-full" data-id="element-106">
            <span className="w-1 h-1 rounded-full bg-gold" data-id="element-107"></span>1 Tomo
          </span>
          <span className="text-gold/60 text-[12px] font-light" data-id="element-108">+</span>
          <span className="inline-flex items-center gap-1.5 bg-white/5 border border-white/10 text-white/80 text-[11px] font-medium py-1.5 px-3 rounded-full" data-id="element-109">
            <span className="w-1 h-1 rounded-full bg-gold" data-id="element-110"></span>1 Bono
          </span>
          <span className="text-gold/60 text-[12px] font-light" data-id="element-111">+</span>
          <span className="inline-flex items-center gap-1.5 bg-white/5 border border-white/10 text-white/80 text-[11px] font-medium py-1.5 px-3 rounded-full" data-id="element-112">
            <span className="w-1 h-1 rounded-full bg-gold" data-id="element-113"></span>
            Test Interactivo
          </span>
        </div>

        <div className="bg-white/5 border-l-2 border-terra py-4 px-5 rounded-r-xl mb-9 animate-fade-up delay-400" data-id="element-114">
          <p className="text-white/80 text-[14px]" data-id="element-115">
            ¿Tus análisis dicen que{' '}
            <strong className="text-white font-semibold" data-id="element-116">todo está bien</strong>
            … pero vos no estás bien? Hay una explicación. Y tiene nombre
            hormonal.
          </p>
        </div>

        <a href="#comprar" className="flex items-center justify-center gap-2 bg-terra text-white font-sans text-[15px] font-semibold py-[18px] px-8 rounded-xl no-underline w-full tracking-[0.01em] shadow-[0_8px_32px_rgba(184,92,56,0.4)] transition-all duration-150 active:scale-98 active:shadow-[0_4px_16px_rgba(184,92,56,0.3)] animate-fade-up delay-500" data-id="element-117">
          Quiero mi guía ahora →
        </a>

        <div className="flex flex-wrap items-center justify-center gap-x-3 gap-y-2 mt-4 animate-fade-up delay-600" data-id="element-118">
          <span className="flex items-center gap-1.5 text-[11px] text-white/40" data-id="element-119">
            📥 Descarga inmediata
          </span>
          <span className="w-px h-3 bg-white/15" data-id="element-120"></span>
          <span className="flex items-center gap-1.5 text-[11px] text-white/40" data-id="element-121">
            📱 En tu celular
          </span>
          <span className="w-px h-3 bg-white/15" data-id="element-122"></span>
          <span className="flex items-center gap-1.5 text-[11px] text-white/40" data-id="element-123">
            🎁 Test incluido
          </span>
          <span className="w-px h-3 bg-white/15" data-id="element-124"></span>
          <span className="flex items-center gap-1.5 text-[11px] text-white/40" data-id="element-125">
            🛡️ Garantía 7 días
          </span>
        </div>
      </div>
    </section>;
}